// extracted by mini-css-extract-plugin
module.exports = {"products":"ProductsContainer_products__15UGq"};